import React, { Fragment } from "react";
import AccountDataSection from "./data-section";
import AccountDataField from "./data-field";
import { allCountries } from "../forms/_sub-forms/customer-data/all-countries";
import AccountInvoices from "./invoices";
var AccountData = function AccountData(_ref) {
    var customerData = _ref.customerData;
    var evaluateCountryName = function evaluateCountryName(countryCode) {
        return allCountries.find(function (elem) {
            return elem.code == countryCode;
        }).name;
    };
    var isTrial = customerData.subscription.status == 'trial';
    var isCanceled = customerData.subscription.status == 'canceled';
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap pt-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-3xl mb-2"
    }, "Ihre Daten"), /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pr-4"
    }, /*#__PURE__*/ React.createElement(AccountDataSection, {
        heading: "Pers\xF6nliche Daten"
    }, /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Kundennummer",
        value: customerData.customer.customerNumber
    }), customerData.customer.academicTitle && /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Titel",
        value: customerData.customer.academicTitle
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Anrede",
        value: customerData.customer.salutation
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Vorname",
        value: customerData.customer.firstName
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Nachname",
        value: customerData.customer.lastName
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "E-Mail Adresse",
        value: customerData.customer.email
    })), /*#__PURE__*/ React.createElement(AccountDataSection, {
        heading: "Adressdaten"
    }, /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Adresse",
        value: customerData.address.address
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "PLZ",
        value: customerData.address.postalCode
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Ort",
        value: customerData.address.city
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Land",
        value: customerData.address.country ? evaluateCountryName(customerData.address.country) : ""
    })), /*#__PURE__*/ React.createElement(AccountDataSection, {
        heading: "Zahlungsdaten"
    }, /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Zahlungsart",
        value: customerData.payment.method
    }), customerData.payment.method == 'SEPA-Lastschrift' && /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Bank",
        value: customerData.payment.bankName
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "IBAN",
        value: customerData.payment.iban
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "BIC",
        value: customerData.payment.bic
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Kontoinhaber",
        value: customerData.payment.accountOwner
    })), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Saldo",
        value: customerData.payment.balance
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-3 md:w-1/2 md:pl-4 md:mt-0"
    }, /*#__PURE__*/ React.createElement(AccountDataSection, {
        heading: "Ihr Abonnement"
    }, /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Abo-Typ",
        value: customerData.subscription.type
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Intervall",
        value: customerData.subscription.duration
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Beginn",
        value: customerData.subscription.start
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: isCanceled ? "Kündigungsdatum" : isTrial ? "Ende Probezeitraum" : "Verlängerung",
        value: isCanceled ? customerData.subscription.cancellationDate : customerData.subscription.nextEvent,
        notice: isCanceled ? "Ihr Abonnement wurde gekündigt und endet zu diesem Datum." : isTrial ? "Innerhalb des Probezeitraums können Sie jederzeit kündigen." : "Wenn Sie Ihr Abonnement nicht kündigen, verlängert es sich automatisch."
    }), /*#__PURE__*/ React.createElement(AccountDataField, {
        name: "Preis",
        value: customerData.subscription.price
    })), /*#__PURE__*/ React.createElement(AccountDataSection, {
        heading: "Ihre Rechnungen"
    }, /*#__PURE__*/ React.createElement(AccountInvoices, {
        invoices: customerData.invoices
    }))));
};
export default AccountData;
